<template>
    <div :class="'ap-alert alert-' + type" v-bind="$attrs">
        <slot>Alert text</slot>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            type: String
        },
    }
</script>

<style lang="scss">
    @import '~styles/colors';

    .ap-alert {
        padding: 5px 25px 5px 60px;
        font-size: 14px;
        line-height: 26px;
        min-height: 26px;
        border-radius: 3px;
        margin: 20px 0px 0px 0px;
        color: $main-font-color;
        position: relative;
        background-color: white;
        border: 1px solid;

        &.alert-success {
            border-color: $alert-success-color;

            &::before {
                position: absolute;
                left: 0px;
                top: 0px;
                content: '';
                width: 40px;
                bottom: 0px;
                background-image: url('~icons/alert-success.svg');
                background-repeat: no-repeat;
                background-size: 30px auto;
                background-position: center center;
                background-color: $alert-success-color;
                border: 0px solid red;
            }
        }

        &.alert-error {
            border-color: $alert-error-color;

            &::before {
                position: absolute;
                left: 0px;
                top: 0px;
                content: '';
                width: 40px;
                bottom: 0px;
                background-image: url('~icons/alert-error.svg');
                background-repeat: no-repeat;
                background-size: 20px auto;
                background-position: center center;
                background-color: $alert-error-color;
                border: 0px solid red;
            }
        }
    }
</style>